/**
 * Created by lu on 2018/5/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('../list/List'),
    method: {
        init: function () {
            var self = this;
            var name = 'radio-' + nb.getSeq();
            this.set('itemType', require('../../view/form/RadioItem'));
            this.onChange('items', function (inEvent, inItems) {
                var items = inItems || [];
                var activeIndex = 0;
                $.each(items, function (inIndex, inItem) {
                    var checked = inItem.get('checked');
                    if (checked || checked == 'checked') {
                        activeIndex = inIndex;
                    }
                    inItem.set('name', name);
                });
                if (activeIndex >= 0) {
                    this.set('activeIndex', activeIndex); //设置默认第一个
                }
            }, this);

            //获取点击
            this.onChange('activeIndex', function (inEvent, inIndex) {
                var itemModel = this._getItemModel(inIndex);
                itemModel.setOpts({
                    'checked': true
                });
                this.set('selectedValue',itemModel.get('value'));
            }, this,{before:true});
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/form/RadioList.js
// module id = 52
// module chunks = 0 2 3 8 9 15 22 23